{
  "app": { "name": "Kinta", "tagline": "Know what you can spend." },
  "common": {
    "loading": "Loading…",
    "save": "Save",
    "cancel": "Cancel",
    "close": "Close",
    "back": "Back",
    "retry": "Try again",
    "email": "Email",
    "password": "Password",
    "newPassword": "New password",
    "name": "Name",
    "optional": "optional",
    "or": "or",
    "offline": "You are offline. Changes will sync when you are back online.",
    "updateReady": "A new version is ready.",
    "reload": "Update",
    "delete": "Delete",
    "errors": {
      "generic": "Something went wrong. Try again.",
      "network": "No connection. Try again when you are online.",
      "forbidden": "You do not have permission to do that.",
      "notFound": "That no longer exists.",
      "conflict": "That already exists.",
      "required": "This field is required.",
      "loadFailed": "Could not load this. Try again."
    }
  },
  "nav": {
    "home": "Home",
    "transactions": "Transactions",
    "budgets": "Budgets",
    "more": "More",
    "add": "Add",
    "search": "Search or jump to…",
    "go": "Go to"
  },
  "auth": {
    "login": { "title": "Welcome back", "submit": "Sign in", "toRegister": "New here? Create an account", "forgot": "Forgot password?" },
    "register": { "title": "Create your account", "submit": "Create account", "toLogin": "Already have an account? Sign in", "fullName": "Your name", "terms": "By creating an account you agree to:" },
    "google": { "continue": "Continue with Google", "failed": "Google sign-in failed. Try again." },
    "forgot": { "title": "Reset your password", "body": "Enter your email and we will send you a link.", "submit": "Send link", "sent": "If that email has an account, a reset link is on its way." },
    "reset": { "title": "Choose a new password", "submit": "Change password", "done": "Password changed. Sign in with the new one.", "invalid": "This link is invalid or expired." },
    "verify": { "title": "Confirm your email", "working": "Confirming…", "ok": "Email confirmed. Thank you!", "invalid": "This confirmation link is invalid or expired.", "continue": "Continue" },
    "banner": {"unverified": "We sent a confirmation link to {{email}}. Open it to unlock everything.", "resend": "Resend email", "resendIn": "Resend in {{seconds}}s", "resent": "Email sent. Check your inbox and spam folder.", "tooSoon": "Please wait a moment before asking again.", "dismiss": "Hide"},
    "errors": {
      "invalidCredentials": "Wrong email or password.",
      "emailTaken": "An account with that email already exists.",
      "tooMany": "Too many attempts. Wait a minute and try again.",
      "generic": "Something went wrong. Try again."
    },
    "validation": { "email": "Enter a valid email address.", "required": "This field is required.", "passwordShort": "Use at least 10 characters." },
    "signOut": "Sign out"
  },
  "install": {
    "title": "Install the app",
    "body": "Open it from your home screen, full screen, and keep adding expenses offline.",
    "button": "Install",
    "ios": "Tap the Share button in Safari, then “Add to Home Screen”."
  },
  "household": {
    "title": "Household",
    "workspaces": "Workspaces",
    "active": "Active workspace",
    "newWorkspace": "New workspace",
    "rename": "Rename",
    "deleteWorkspace": "Delete workspace",
    "deleteTitle": "Delete {{name}}?",
    "deleteBody": "This erases the workspace and all its data for everyone in it. It cannot be undone.",
    "members": "Members",
    "you": "you",
    "roleOf": "Role of {{name}}",
    "role": "Role",
    "remove": "Remove",
    "removeTitle": "Remove this person?",
    "removeBody": "{{name}} will lose access to this workspace.",
    "leave": "Leave workspace",
    "leaveTitle": "Leave this workspace?",
    "leaveBody": "You will lose access until someone invites you again.",
    "invitations": "Invitations",
    "noInvitations": "No pending invitations.",
    "invite": "Invite someone",
    "inviteHint": "We email them a link that works for 7 days.",
    "sendInvite": "Send invitation",
    "revoke": "Cancel",
    "inviteInvalid": "Enter a valid email address.",
    "inviteConflict": "That person is already here, or sending email is not set up.",
    "viewOnly": "You can look but not change anything in this workspace.",
    "roles": {
      "owner": "Owner",
      "admin": "Manager",
      "member": "Member",
      "viewer": "Viewer"
    },
    "roleHint": {
      "admin": "edits and manages people",
      "member": "edits entries",
      "viewer": "read only"
    },
    "invitePage": {
      "title": "You are invited",
      "body": "{{inviter}} invited you to {{workspace}} as {{role}}.",
      "forEmail": "This invitation is for {{email}}.",
      "accept": "Join workspace",
      "notFound": "This invitation link is not valid.",
      "used": "This invitation was already used.",
      "expired": "This invitation has expired. Ask for a new one.",
      "wrongAccount": "This invitation was sent to a different email address. Sign in with that one.",
      "verifyFirst": "Confirm your email first, then come back to this link.",
      "pending": "You have an invitation waiting.",
      "open": "Open"
    }
  },
  "account": {
    "title": "Your data",
    "body": "Download a copy of everything you can see, or delete your account for good.",
    "export": "Download my data",
    "exportFailed": "Could not prepare the file. Try again.",
    "delete": {
      "open": "Delete account",
      "title": "Delete your account?",
      "body": "This erases your account, your workspaces and every transaction, budget and receipt in them. It cannot be undone. Download your data first if you want a copy.",
      "typeEmail": "Type {{email}} to confirm",
      "confirm": "Delete everything",
      "wrongInput": "The email or password does not match.",
      "sharedWorkspace": "A workspace of yours still has other members. Remove them first, then try again."
    },
    "legal": {
      "privacy": "Privacy policy",
      "terms": "Terms of use"
    }
  },
  "legal": {
    "back": "Back",
    "draftNote": "Draft text. The operator details are filled in before launch.",
    "updated": "Last updated: {{date}}",
    "contact": "Questions: {{email}}",
    "privacy": {
      "title": "Privacy policy",
      "sections": [
        {
          "h": "Who we are",
          "p": "{{name}} is a personal finance app. The operator of the service is {{operator}}. Contact: {{email}}."
        },
        {
          "h": "What we store",
          "p": "Your email, name (if given), language and a password hash (never the password). If you sign in with Google, we receive your Google account id and verified email. Everything you enter: accounts, transactions, categories, budgets, bills, goals, receipt photos and workspace settings. Technical data: IP address and device name for sign-in sessions and security logs."
        },
        {
          "h": "Why we use it",
          "p": "To run the app for you (contract), to keep it secure and prevent abuse (legitimate interest), and to bill you and meet tax rules (legal duty). We do not sell your data, show ads or build advertising profiles."
        },
        {
          "h": "Who else handles it",
          "p": "Hosting and backups: Hetzner, in the EU. Payments: Stripe, which handles card details; we keep only your Stripe customer id, plan and payment status. Email delivery: our email provider, for confirmation and reset emails. Sign-in with Google: Google, only if you choose it. Currency rates come from public ECB data and carry none of your data."
        },
        {
          "h": "Cookies and storage",
          "p": "We use no advertising or tracking cookies. Your browser stores your sign-in session, language, theme and a local copy of your data so the app works offline."
        },
        {
          "h": "How long we keep it",
          "p": "While your account exists. When you delete it, your data is erased from the live database at once. Backups roll off within 30 days. Payment records may be kept as long as tax law requires."
        },
        {
          "h": "Your rights",
          "p": "You can see, correct, export and delete your data. Export and delete are in More, under Your data. You can also ask us by email, object to processing, or complain to the Croatian data protection authority (AZOP)."
        },
        {
          "h": "Changes",
          "p": "If this policy changes in a way that matters, we will tell you in the app or by email before it applies."
        }
      ]
    },
    "terms": {
      "title": "Terms of use",
      "sections": [
        {
          "h": "The service",
          "p": "{{name}} helps you track your own money. It is a tool, not financial, tax or legal advice. Figures depend on what you enter and on public exchange rates."
        },
        {
          "h": "Your account",
          "p": "You must be at least 16. Keep your password safe and give correct details. You are responsible for what happens under your account. Invite only people you trust to your workspaces."
        },
        {
          "h": "Your data",
          "p": "Your data stays yours. You allow us to store and process it only to run the service. You can export it and delete your account at any time."
        },
        {
          "h": "Plans and payment",
          "p": "New accounts get a 14-day free trial. After the trial the app keeps working and shows a reminder to buy a plan. Pro costs 4.99 EUR a month or 49 EUR a year, Lifetime costs 99 EUR once. Prices include VAT where it applies. Subscriptions renew until you cancel in the customer portal. Under EU consumer law you may withdraw within 14 days of buying, unless you agreed to start the service at once; contact us and we will refund as the law requires."
        },
        {
          "h": "Acceptable use",
          "p": "Do not attack, overload or reverse engineer the service, do not use it to break the law, and do not try to reach other people's data."
        },
        {
          "h": "Availability and liability",
          "p": "We work to keep the service running and your data safe, but we give no guarantee that it is always available or error free. We are not liable for indirect loss. Nothing here limits rights you have by law."
        },
        {
          "h": "Ending the service",
          "p": "You may stop at any time by deleting your account. We may suspend accounts that break these terms. If we ever close the service, we will give notice and time to export your data."
        },
        {
          "h": "Law",
          "p": "Croatian law applies. Disputes go to the courts in Croatia, without affecting your consumer rights in your own country."
        }
      ]
    }
  },
  "settings": {
    "title": "More",
    "account": "Account",
    "language": "Language",
    "theme": "Appearance",
    "themeDark": "Dark",
    "themeLight": "Light",
    "themeSystem": "System",
    "workspace": "Workspace",
    "currency": "Currency",
    "version": "Version {{version}}"
  },
  "home": { "greeting": "Hi{{name}}" },
  "accounts": {
    "title": "Accounts",
    "add": "Add account",
    "edit": "Edit account",
    "type": "Type",
    "openingBalance": "Opening balance",
    "makeDefault": "Use as default account",
    "default": "Default",
    "archived": "Archived",
    "archive": "Archive",
    "unarchive": "Restore",
    "empty": "No accounts yet",
    "emptyHint": "Add the account you pay from, such as your card or cash.",
    "deleteTitle": "Delete {{name}}?",
    "deleteBody": "The account disappears from your lists. Archiving keeps its history and is usually better.",
    "types": { "checking": "Checking", "cash": "Cash", "savings": "Savings", "credit_card": "Credit card", "loan": "Loan", "investment": "Investment", "ewallet": "E-wallet", "other": "Other" }
  },
  "categories": {
    "title": "Categories",
    "add": "Add category",
    "edit": "Edit category",
    "expense": "Expenses",
    "income": "Income",
    "deleteTitle": "Delete {{name}}?",
    "deleteBody": "Past transactions keep their amounts but lose this category."
  },
  "rules": {
    "title": "Auto-categorise",
    "hint": "When a new expense has no category and the merchant contains the text, it gets the category.",
    "row": "“{{pattern}}” → {{category}}",
    "pattern": "Merchant contains",
    "category": "Category",
    "add": "Add rule",
    "delete": "Delete rule {{pattern}}"
  },
  "import": {
    "title": "Import CSV",
    "account": "Import into account",
    "file": "Bank export (CSV)",
    "fileHint": "Up to {{max}} rows. The file is read on this device and only the mapped columns are sent.",
    "errors": { "empty": "That file has no data rows.", "tooMany": "That file has more than {{max}} rows. Split it and import in parts." },
    "columns": { "date": "Date column", "amount": "Amount column", "merchant": "Merchant column", "note": "Note column" },
    "choose": "Choose column",
    "none": "Not in the file",
    "dateFormat": "Date format",
    "formats": { "iso": "2026-10-17", "dmy-dot": "17.10.2026", "dmy-slash": "17/10/2026", "mdy-slash": "10/17/2026" },
    "positiveIsExpense": "Positive amounts are expenses (credit card exports)",
    "summary": "{{ready}} rows ready, {{skipped}} skipped (bad date or amount).",
    "preview": "Preview",
    "start": "Import {{count}} rows",
    "progress": "Importing… {{done}} of {{total}}",
    "done": "Import finished",
    "stopped": "Import stopped",
    "result": "Added or matched: {{created}}. Skipped: {{failed}}.",
    "safeToRetry": "Connection or server problem. Try again: rows already imported are not duplicated.",
    "retry": "Try again",
    "needAccount": "Add an account first:"
  },
  "receipt": {
    "has": "Has receipt",
    "add": "Add receipt photo",
    "replace": "Change photo",
    "remove": "Remove photo",
    "file": "Receipt photo",
    "list": "Receipts",
    "delete": "Delete receipt {{name}}",
    "alt": "Receipt",
    "download": "Download",
    "uploadFailed": "Saved, but the photo did not upload. Press Save to try again."
  },
  "offline": {
    "section": "Not synced yet",
    "badgePending": "Waiting to sync",
    "badgeFailed": "Not synced",
    "pendingTitle": "Waiting to sync",
    "failedTitle": "Could not sync",
    "kind": {
      "create": "This new transaction is saved on this device and is sent as soon as you are online.",
      "update": "This change is saved on this device and is sent as soon as you are online.",
      "delete": "This delete is saved on this device and is sent as soon as you are online."
    },
    "failedHint": "The server did not accept it. Try again, or discard it.",
    "retry": "Try again",
    "discard": "Discard",
    "discardTitle": "Discard this change?",
    "discardBody": "It has not been sent yet. If you discard it, it is lost.",
    "syncing": "Syncing changes: {{count}}",
    "queued": "Saved on this device, waiting for a connection: {{count}}",
    "failedBar": "Changes that could not be synced: {{count}}",
    "review": "Review",
    "photoNeedsConnection": "Photos need a connection."
  },
  "bills": {
    "title": "Bills",
    "add": "Add bill",
    "edit": "Edit bill",
    "amount": "Amount",
    "nextDue": "Next due",
    "repeatEvery": "Repeat every",
    "unit": "Unit",
    "units": { "month": "months", "week": "weeks", "year": "years", "day": "days" },
    "every1": { "day": "Daily", "week": "Weekly", "month": "Monthly", "year": "Yearly" },
    "everyN": { "day": "Every {{n}} days", "week": "Every {{n}} weeks", "month": "Every {{n}} months", "year": "Every {{n}} years" },
    "none": "None",
    "accountHint": "Needed to record payments as expenses.",
    "remindDays": "Remind me this many days before",
    "markPaid": "Mark paid",
    "payTitle": "Pay {{name}}?",
    "recordOn": "Also record it as an expense on {{account}}",
    "recordNeedsAccount": "Add an account to this bill to record payments as expenses.",
    "empty": "No bills yet",
    "emptyHint": "Add rent, subscriptions or loan payments and see what is due next.",
    "deleteTitle": "Delete this bill?",
    "deleteBody": "Past payments stay in your transactions.",
    "due": { "today": "Due today", "tomorrow": "Due tomorrow", "yesterday": "Was due yesterday", "in": "Due in {{count}} days", "ago": "Overdue by {{count}} days" },
    "errors": { "interval": "Enter a number from 1 to 120.", "reminder": "Enter a number from 0 to 60.", "stale": "This bill was already paid. The list has been refreshed." }
  },
  "onboarding": {
    "progress": "Step {{n}} of {{total}}",
    "next": "Next",
    "skipStep": "Skip this step",
    "welcome": {
      "title": "Welcome to Kinta",
      "lead": "A minute to set up, then it is yours.",
      "cta": "Let's start"
    },
    "tips": {
      "add": {
        "title": "Add a transaction in seconds.",
        "body": "Tap the plus button, type the amount, pick a category. It works offline too."
      },
      "budgets": {
        "title": "Set budgets.",
        "body": "Give a category or your whole month a limit and Kinta tells you what is safe to spend."
      },
      "bills": {
        "title": "Never miss a bill.",
        "body": "Add recurring bills and get a reminder before they are due."
      }
    },
    "account": {
      "title": "Your first account",
      "lead": "Where your money lives: a bank account, a card or cash. You can add more later."
    },
    "budget": {
      "title": "A monthly budget",
      "lead": "Optional, and easy to change later.",
      "body": "How much do you want to spend in a month, all together?",
      "label": "Monthly limit ({{currency}})"
    },
    "done": {
      "title": "You are all set",
      "lead": "Add your first transaction with the plus button.",
      "cta": "Open Kinta"
    }
  },
  "billing": {
    "badge": "Supporter",
    "thanksSupporter": "Thank you for supporting Kinta.",
    "since": "Since {{date}}.",
    "inviteTitle": "Kinta is free",
    "inviteBody": "Everything in Kinta is free, for everyone. If it helps you, you can become a supporter with one small payment. You get a badge and never see a reminder again.",
    "support": "Become a supporter · {{price}}",
    "supporterPlan": "Supporter",
    "reminderTitle": "Today is the owner's birthday",
    "reminderBody": "Kinta is free. If it helps you, you can support its maker with a small gift today. You will not be asked again this year.",
    "notNow": "Not now",
    "thanks": "Thank you! Your supporter badge appears in a moment.",
    "canceled": "Checkout canceled. Nothing was charged.",
    "mock": {
      "banner": "Test mode: this page stands in for the payment provider. Nothing is charged.",
      "title": "Test checkout",
      "invalid": "This test checkout link is invalid or has expired. Start again from Settings.",
      "pay": "Pay (test)"
    }
  },
  "reports": {
    "title": "Reports",
    "period": "Period",
    "presets": { "thisMonth": "This month", "lastMonth": "Last month", "last3": "Last 3 months", "thisYear": "This year", "custom": "Custom" },
    "badRange": "Pick a start and an end day, in that order, within five years.",
    "topMerchants": "Top merchants",
    "times": "{{n}}×",
    "export": "Export",
    "exportHint": "All transactions from {{from}} to {{to}} as a spreadsheet file (CSV). You can import the same file again.",
    "downloadCsv": "Download CSV"
  },
  "goals": {
    "title": "Goals",
    "new": "New goal",
    "edit": "Edit goal",
    "target": "Target amount",
    "savedSoFar": "Saved so far",
    "targetDate": "Reach it by",
    "account": "Saving in account",
    "statusLabel": "Status",
    "status": { "active": "Active", "paused": "Paused", "achieved": "Achieved", "archived": "Archived" },
    "by": "By {{date}}",
    "perMonth": "{{amount}} a month to get there",
    "addMoney": "Add money",
    "contributeTitle": "{{name}}",
    "direction": "Add or withdraw",
    "add": "Add",
    "withdraw": "Withdraw",
    "empty": "No goals yet",
    "emptyHint": "Save for a holiday, an emergency fund or a new laptop, and watch it grow.",
    "deleteTitle": "Delete this goal?",
    "deleteBody": "This cannot be undone. Your transactions are not affected.",
    "errors": { "saved": "Enter an amount, or leave it empty." }
  },
  "budgets": {
    "add": "Add budget",
    "edit": "Edit budget",
    "for": "Budget for",
    "targets": { "category": "Category", "group": "Group", "all": "All spending" },
    "choose": "Choose…",
    "overall": "All spending",
    "amount": "Limit",
    "period": "Period",
    "periods": { "weekly": "Weekly", "monthly": "Monthly", "quarterly": "Quarterly", "yearly": "Yearly" },
    "threshold": "Warn me at (%)",
    "thresholdHint": "The bar turns amber when this share of the limit is spent.",
    "of": "of",
    "left": "{{amount}} left",
    "over": "{{amount}} over",
    "empty": "No budgets yet",
    "emptyHint": "Set a limit for a category, such as groceries, and watch it fill up.",
    "deleteTitle": "Delete this budget?",
    "deleteBody": "Your transactions are not affected.",
    "errors": { "amount": "Enter an amount above zero.", "threshold": "Enter a number from 1 to 100.", "exists": "There is already a budget for this and period." }
  },
  "dashboard": {
    "safeToSpend": "Safe to spend",
    "income": "Income",
    "spent": "Spent",
    "net": "Net",
    "vsLastMonth": "{{change}} spending vs last month",
    "byCategory": "Where it went",
    "noSpending": "No spending this month yet.",
    "trend": "Last 6 months",
    "upcomingBills": "Upcoming bills",
    "recent": "Recent",
    "seeAll": "See all",
    "loadFailed": "Could not load your overview."
  },
  "pages": {
    "transactions": "Transactions",
    "budgets": "Budgets",
    "notFound": "We could not find that page."
  },
  "quickAdd": { "title": "Add transaction", "backspace": "Delete last digit", "category": "Category", "more": "More ({{count}})", "less": "Less", "failed": "Could not save. Try again." },
  "tx": {
    "noAccount": "Add an account first, such as your card or cash. Then you can record spending in two taps.",
    "bulk": {
      "select": "Select",
      "cancel": "Cancel",
      "selectAll": "Select all",
      "selected": "Selected: {{count}}",
      "limit": "limit {{max}}",
      "setCategory": "Set category",
      "chooseCategory": "Choose category",
      "apply": "Apply",
      "deleteTitle": "Delete the selected transactions ({{count}})?"
    },
    "search": "Search merchant or note",
    "filters": {
      "title": "Filters",
      "withCount": "Filters, {{count}} active",
      "any": "Any",
      "uncategorized": "No category",
      "from": "From",
      "to": "To",
      "clear": "Clear all",
      "done": "Done",
      "noMatch": "Nothing matches these filters"
    },
    "edit": "Edit transaction",
    "kind": "Type",
    "moreDetails": "More details",
    "merchant": "Merchant",
    "account": "Account",
    "fromAccount": "From account",
    "toAccount": "To account",
    "chooseAccount": "Choose account",
    "date": "Date",
    "note": "Note",
    "deleteTitle": "Delete this transaction?",
    "deleteBody": "It is removed from your lists, balances and totals.",
    "today": "Today",
    "yesterday": "Yesterday",
    "loadMore": "Load more",
    "loadFailed": "Could not load transactions.",
    "empty": "No transactions yet",
    "emptyHint": "Tap + to add your first expense.",
    "type": { "expense": "Expense", "income": "Income", "transfer": "Transfer" }
  }
}
